module.exports = __webpack_public_path__ + "assets/media/robot_ide.a85e03ec.mp4";